'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _helpers = require('./../../helpers');

var _feedback = require('redux/modules/feedback');

var _components = require('./../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContainerModalFeedback = (_dec = (0, _reactRedux.connect)(function (state) {
  return (0, _helpers.mapConnect)(state, {
    done: 'feedback.done',
    isModalVisible: 'feedback.isModalVisible',
    isSendingFeedback: 'feedback.isSendingFeedback',
    sendFeedbackError: 'feedback.sendFeedbackError'
  });
}, { showModalFeedback: _feedback.showModalFeedback, hideModalFeedback: _feedback.hideModalFeedback, sendFeedback: _feedback.sendFeedback, setModalStatus: _feedback.setModalStatus, clearFeedbackError: _feedback.clearFeedbackError }, null, { withRef: true }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ContainerModalFeedback, _Component);

  function ContainerModalFeedback() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ContainerModalFeedback);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ContainerModalFeedback.__proto__ || (0, _getPrototypeOf2.default)(ContainerModalFeedback)).call.apply(_ref, [this].concat(args))), _this), _this.showModal = function () {
      var _this$props = _this.props,
          setModalStatus = _this$props.setModalStatus,
          clearFeedbackError = _this$props.clearFeedbackError,
          showModalFeedback = _this$props.showModalFeedback;

      setModalStatus(false);
      clearFeedbackError();
      showModalFeedback();
    }, _this.handleSubmit = function (data) {
      var _this$props2 = _this.props,
          sendFeedback = _this$props2.sendFeedback,
          setModalStatus = _this$props2.setModalStatus;

      sendFeedback(data).then(function () {
        setModalStatus(true);
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ContainerModalFeedback, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          sendFeedbackError = _props.sendFeedbackError,
          done = _props.done,
          isModalVisible = _props.isModalVisible,
          hideModalFeedback = _props.hideModalFeedback,
          isSendingFeedback = _props.isSendingFeedback;

      var props = {
        done: done,
        isModalVisible: isModalVisible,
        onModalHide: hideModalFeedback,
        handleSubmit: this.handleSubmit,
        isLoading: isSendingFeedback,
        err: sendFeedbackError
      };
      return _react2.default.createElement(_components.ModalFeedback, props);
    }
  }]);
  return ContainerModalFeedback;
}(_react.Component), _class2.propTypes = {
  hideModalFeedback: _react.PropTypes.func.isRequired,
  setModalStatus: _react.PropTypes.func.isRequired,
  clearFeedbackError: _react.PropTypes.func.isRequired,
  isModalVisible: _react.PropTypes.bool.isRequired,
  done: _react.PropTypes.bool.isRequired,
  isSendingFeedback: _react.PropTypes.bool.isRequired,
  sendFeedback: _react.PropTypes.func.isRequired,
  showModalFeedback: _react.PropTypes.func.isRequired,
  sendFeedbackError: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object])
}, _temp2)) || _class);
exports.default = ContainerModalFeedback;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ContainerModalFeedback/ContainerModalFeedback.js
 ** module id = 1236
 ** module chunks = 0
 **/